(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whimsy-wins"] && !Shopify.designMode) return;
  try {
    
function setupWinEmailPermission(root) {
  for (const form of root.querySelectorAll('.ww-wins__form form')) {
    if (form.dataset.wwEmailReady) continue;
    const body = form.querySelector('[name="comment[body]"]');
    const choice = form.querySelector('[name="email_encouragement"]');
    if (!body || !choice || !('FormDataEvent' in window)) continue;
    form.dataset.wwEmailReady = 'true';
    choice.disabled = false;
    for (const element of form.querySelectorAll('[data-ww-email-choice]')) element.hidden = false;
    form.addEventListener('formdata', (event) => {
      const text = body.value.split('[WW-EMAIL-PERMISSION:')[0].trimEnd();
      const permission = choice.checked ? 'YES' : 'NO';
      event.formData.set('comment[body]', text + '\n\n[WW-EMAIL-PERMISSION: ' + permission + ']');
      event.formData.delete('email_encouragement');
    });
  }
}
setupWinEmailPermission(document);
document.addEventListener('shopify:section:load', (event) => setupWinEmailPermission(event.target));

function setupWinHearts(root) {
  for (const wall of root.querySelectorAll('[data-ww-hearts]')) {
    if (wall.dataset.wwHeartsReady) continue;
    wall.dataset.wwHeartsReady = 'true';
    const buttons = [...wall.querySelectorAll('[data-ww-heart]')];
    if (!buttons.length) continue;
    const endpoint = wall.dataset.wwHearts;
    const states = new Map();
    let visitor;
    try { visitor = localStorage.getItem('ww-heart-visitor'); } catch {}
    if (!/^[a-f0-9-]{36}$/i.test(visitor || '')) {
      visitor = crypto.randomUUID();
      try { localStorage.setItem('ww-heart-visitor', visitor); } catch {}
    }
    const show = (button, state) => {
      button.querySelector('[data-ww-heart-count]').textContent = String(state.count);
      button.querySelector('[data-ww-heart-icon]').textContent = state.liked ? '♥' : '♡';
      button.setAttribute('aria-pressed', String(state.liked));
      button.setAttribute('aria-label', state.liked ? wall.dataset.heartRemove : wall.dataset.heartAdd);
    };
    const load = async () => {
      const url = new URL(endpoint);
      url.searchParams.set('ids', [...new Set(buttons.map(b => b.dataset.wwHeart))].join(','));
      url.searchParams.set('visitor', visitor);
      const response = await fetch(url, {credentials:'omit', signal:AbortSignal.timeout(8000)});
      if (!response.ok) throw new Error('Hearts unavailable');
      const data = await response.json();
      if (!Array.isArray(data.states)) throw new Error('Invalid heart response');
      for (const state of data.states) states.set(state.id, state);
      for (const button of buttons) {
        const state = states.get(button.dataset.wwHeart);
        if (!state || !Number.isInteger(state.count) || state.count < 0) continue;
        show(button, state);
        button.disabled = false;
      }
    };
    for (const button of buttons) {
      button.addEventListener('click', async () => {
        const id = button.dataset.wwHeart;
        let state = states.get(id);
        if (!state) return;
        const desired = !state.liked;
        const status = button.parentElement.querySelector('[data-ww-heart-status]');
        button.disabled = true;
        status.textContent = '';
        try {
          if (state.expires <= Date.now()/1000) { await load(); state = states.get(id); }
          button.disabled = true;
          const response = await fetch(endpoint, {method:'POST',credentials:'omit',headers:{'Content-Type':'application/json'},body:JSON.stringify({id,visitor,liked:desired,expires:state.expires,token:state.token}),signal:AbortSignal.timeout(8000)});
          if (!response.ok) throw new Error('Unable to save heart');
          const result = await response.json();
          if (result.id !== id || !Number.isInteger(result.count) || result.count < 0 || result.liked !== desired) throw new Error('Invalid heart response');
          state = {...state, ...result};
          states.set(id, state);
          show(button, state);
          status.textContent = desired ? wall.dataset.heartThanks : wall.dataset.heartRemoved;
        } catch { status.textContent = wall.dataset.heartError; }
        finally { button.disabled = false; }
      });
    }
    load().catch(() => {
      for (const button of buttons) button.parentElement.querySelector('[data-ww-heart-status]').textContent = wall.dataset.heartError;
    });
  }
}
setupWinHearts(document);
document.addEventListener('shopify:section:load', (event) => setupWinHearts(event.target));

  } catch(e) { console.error(e); }
})();
})();
